export const availValidationData = (payload) => {
  let errors = []

  if (!payload?.destination?._id)
    errors.push({
      type: 'keyword',
      message: 'Destino es requerido'
    })
  if (!payload?.countryCode || !payload?.country)
    errors.push({
      type: 'nationality',
      message: 'Nacionalidad es requerida'
    })
  if (!payload?.start || !payload?.end)
    errors.push({
      type: 'checking',
      message: 'Checking es requerido'
    })

  if (!payload?.totalNumberOfPeople)
    errors.push({
      type: 'rooms',
      message: 'Número de personas es requerido'
    })
  
  if (!payload?.provider)
    errors.push({
      type: 'provider',
      message: 'Seleccione usuario de proveedor'
    })

  return {
    errors: errors.length ? true : false,
    data: errors
  }
}
export const availResteValidationData = (payload) => {
  let errors = []

  if (!payload?.provider_id)
    errors.push({
      type: 'provider',
      message: 'Proveedor no seleccionado'
    })
  
    if (!payload?.destination?._id)
    errors.push({
      type: 'keyword',
      message: 'Destino es requerido'
    })
    
  if (!payload?.countryCode || !payload?.country)
    errors.push({
      type: 'nationality',
      message: 'Nacionalidad es requerida'
    })
  if (!payload?.start || !payload?.end)
    errors.push({
      type: 'checking',
      message: 'Checking es requerido'
    })

  if (!payload?.totalNumberOfPeople)
    errors.push({
      type: 'rooms',
      message: 'Número de personas es requerido'
    })

  return {
    errors: errors.length ? true : false,
    data: errors
  }
}
